import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public loaderEvent = new EventEmitter<boolean>();
  constructor() {}
}
